module.exports = __webpack_public_path__ + "i18n/ru.c5805eb8a62d1ce3029d4e2a14fa01c0.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1316
// module chunks = 59